import { Button, FormControl, InputGroup } from "react-bootstrap";
import Icon from "../../common/components/Icon";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RDraw } from "rlayers/interaction";
import { LineString, Polygon } from "ol/geom";
import { RLayerVector } from "rlayers";
import { useMapHandlers } from "./MapHandlers";
import { getLength as getGeodesicLength, getArea as getGeodesicArea } from "ol/sphere";

export const RMeasure = ({ style }) => {
    const { t } = useTranslation();
    const { register } = useMapHandlers();
    const [metric, setMetric] = useState(true);
    const [drawDistance, setDrawDistance] = useState(false);
    const [distance, setDistance] = useState(0);
    const [liveDistance, setLiveDistance] = useState(0);

    const [drawArea, setDrawArea] = useState(false);
    const [liveArea, setLiveArea] = useState(0);
    const [area, setArea] = useState(0);

    const handleMapClick = useCallback(() => drawDistance || drawArea, [drawDistance, drawArea]);

    useEffect(() => register(handleMapClick, 100), [register, handleMapClick]);

    const handleDistanceDrawStart = (event) => {
        event.feature.getGeometry().on('change', (e) => {
            // This function is called whenever a new vertex is added
            const geom = e.target;
            const lenM = getGeodesicLength(geom, { projection: "EPSG:3857" });
            setLiveDistance(lenM);
        });
    }

    const handleDistanceDrawEnd = (event) => {
        setLiveDistance(0);
        const geometry = event.feature.getGeometry();
        if (geometry instanceof LineString) {
            const lenM = getGeodesicLength(geometry, { projection: "EPSG:3857" });
          setDistance(distance => distance + lenM);
        }
      };

    const handleAreaDrawStart = (event) => {
        event.feature.getGeometry().on('change', (e) => {
            // This function is called whenever a new vertex is added
            const geom = e.target;
            const areaM2 = getGeodesicArea(geom, { projection: "EPSG:3857" });
            setLiveArea(areaM2);
        });
    }

    const handleAreaDrawEnd = (event) => {
        setLiveDistance(0);
        const geometry = event.feature.getGeometry();
        if (geometry instanceof Polygon) {
          setDistance(distance => distance + geometry.getArea());
        }
      };

    return <>
        <div style={{maxWidth: '250px', ...style, zIndex: 80}}>
        <InputGroup>
            <InputGroup.Prepend>
                <Button id="mapCalcDistance" variant="primary" disabled={drawArea} title={t('distance')} style={{ width: '38px' }} onClick={() => { setDrawDistance(draw => !draw); setDistance(0); setLiveDistance(0); }}><Icon variant="solid" kind="ruler-horizontal"></Icon></Button>
            </InputGroup.Prepend>
            { drawDistance ? <FormControl type="text" value={((distance + liveDistance) * (metric ? 1 : 3.28084 ))?.toFixed(2)} placeholder={t('distance')} disabled={true}></FormControl> : null }
            { drawDistance ? <InputGroup.Append>
                <Button variant="default" onClick={() => setMetric(metric => !metric)}>{metric ? 'm' : 'ft'}</Button>
            </InputGroup.Append> : null }
        </InputGroup>
        <InputGroup className="mt-2">
            <InputGroup.Prepend>
                <Button id="mapCalcArea" variant="primary" disabled={drawDistance} title={t('area')} style={{ width: '38px' }} onClick={() => { setDrawArea(draw => !draw); setArea(0); setLiveArea(0); }}><Icon variant="solid" kind="draw-polygon"></Icon></Button>
            </InputGroup.Prepend>
            { drawArea ? <FormControl type="text" value={((area + liveArea) * (metric ? 1 : 10.7639111056))?.toFixed(2)} placeholder={t('area')} disabled={true}></FormControl> : null }
            { drawArea ? <InputGroup.Append>
                <Button variant="default" onClick={() => setMetric(metric => !metric)}>
                    {metric ? 'm' : 'ft'}<sup>2</sup>
                </Button>
            </InputGroup.Append> : null }
        </InputGroup>
        </div>
        { drawDistance ? <RLayerVector><RDraw type="LineString" onDrawStart={handleDistanceDrawStart} onDrawEnd={handleDistanceDrawEnd}></RDraw></RLayerVector> : null}
        { drawArea ? <RLayerVector><RDraw type="Polygon" onDrawStart={handleAreaDrawStart} onDrawEnd={handleAreaDrawEnd}></RDraw></RLayerVector> : null}
    </>
}